import React from 'react';

import { FileObject, LinkObject, ObjectsWithInfo, TaskContent } from '../../model/tasks/types';
import { FileAttribute } from '../FileAttribute';
import { LinkAttribute } from '../LinkAttribute';
import { TableAttribute } from '../TableAttribute';
import { TextAttribute } from '../TextAttribute';
import styles from './Attribute.module.css';

type Props = {
  field: TaskContent;
};

export type AttributeValues = FileObject | LinkObject | ObjectsWithInfo[] | string[] | null;

export const isTextAttribute = (values: AttributeValues): values is string[] => {
  return Array.isArray(values) && typeof values[0] === 'string';
};

export const isTableAttribute = (values: AttributeValues): values is ObjectsWithInfo[] => {
  return Array.isArray(values) && values[0] instanceof Object;
};

export const Attribute: React.FC<Props> = ({ field }) => {
  const getFieldValue = (attribute: AttributeValues) => {
    if (!attribute) {
      return null;
    }

    // FileObject
    if ('versionField' in attribute) {
      return <FileAttribute attribute={attribute.textField} />;
    }

    // LinkObject
    if ('nameField' in attribute) {
      return <LinkAttribute attribute={attribute.textField} />;
    }

    // string[]
    if (isTextAttribute(attribute)) {
      return <TextAttribute attribute={attribute} title={field.titleField} />;
    }

    // ObjectsWithInfo[]
    if (isTableAttribute(attribute)) {
      return <TableAttribute attribute={attribute} />;
    }
  };

  return (
    <div className={styles.item} key={field.idField}>
      <div className={styles.title}>{field.titleField}</div>
      {Object.values(field.valueField).map((values) => getFieldValue(values))}
    </div>
  );
};
